import { render, staticRenderFns } from "./ViewPropertiesTable.vue?vue&type=template&id=21aa36c8"
import script from "./ViewPropertiesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPropertiesTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports